import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpRequestHandler } from '../../models/http-model';
import { HttpService } from '../http.service';

const HEADERS = {}

@Injectable()
export class AccountingnavService {

  static ENV : any = environment;

  readonly default_navs = [
    {
      label: 'Cargue Asientos',
      rute: '/accounting/load-type-menu',
      disabled : false
    },
    {
      label: 'Valida Asientos',
      rute: '/accounting/validate-process',
      disabled : false
    },
    {
      label: 'Generación Balance por Tercero',
      rute: '/accounting/balance-generation-third',
      disabled : false
    },
  ]

  constructor(private _httpService : HttpService) { 
    HEADERS['Content-Type'] = 'application/json';
  }

  /**
   * Función que se encarga de consultar
   */
  getParamsNavAccounting(httpRequesthandler: HttpRequestHandler){

    let url = AccountingnavService.ENV.environment.API.params_nav_accounting;
    httpRequesthandler.headers = HEADERS;
    console.log('=========================================')
    console.log(url)
    console.log('=========================================')
    this._httpService.get(url, httpRequesthandler);

  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/accounting/accountingnav.service.ts